import React from "react";
import { useSidebar } from "../Contexts/sidebar";

export default ({ reset, children }) => {
  const { isDarkMode } = useSidebar();
  return (
    <div className="py-32 min-h-screen w-full fixed inset-0 overflow-auto">
      <div
        className="tint h-full w-full fixed inset-0 bg-black bg-opacity-25"
        onClick={() => {
          reset();
        }}
      />
      <div className={`absolute left-1/2 transform -translate-x-1/2 panel rounded-sm w-1/2 px-4 ${
        isDarkMode ? 'bg-gray-800' : 'bg-white'
      }`}>
        {children}
      </div>
    </div>
  );
};
